import styled from 'styled-components';

import arrowLeft from '~/assets/icon-arrow-left.png';
import arrowRight from '~/assets/icon-arrow-right.png';

export const Container = styled.div`
  position: relative;
  .slick-list {
    /* width: 115%; */
    width: 140%;
  }
  .slick-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 3;
    width: 40px;
    height: 70px;
    border: 0;
    background-color: transparent;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    font-size: 0;
    &.slick-prev {
      left: 0;
      margin-left: -55px;
      background-image: url(${arrowLeft});
    }
    &.slick-next {
      right: 0;
      margin-right: 45px;
      background-image: url(${arrowRight});
    }
  }

  @media (max-width: 1200px) {
    .slick-list {
      width: 100%;
    }
    /* }
  @media (max-width: 992px) { */
    .slick-arrow {
      &.slick-prev {
        margin-left: -15px;
      }
      &.slick-next {
        margin-right: -15px;
      }
    }
  }
  @media (max-width: 768px) {
    .slick-list {
      /* width: 115%; */
      width: 100%;
    }
    .slick-arrow {
      &.slick-next {
        margin-right: -15px;
      }
    }
  }
`;

export const SliderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* flex-direction: column; */
  & > div {
    flex: 0 0 50%;
    max-width: 50%;
    height: auto;
    @media (max-width: 992px) {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;
